import React, { useState } from 'react';
import tw, { styled } from 'twin.macro';

import {
  PageWrapper,
  OneHalfLayout,
  Flex,
  Panel
} from '@sopranodesign/pulse-components';
import { useAuth } from '@sopranodesign/pulse-auth';
import { BackButton } from '@sopranodesign/pulse-channels';

import { BotSettingsProvider } from '../Providers/index';
import {
  FullPageColourSettings,
  FullPageGeneralSettings,
  SettingPageSettings,
  DeploymentCode,
  FullPagePreview,
  FontCode
} from '../Components/index';
import {
  updateFullPageSettings,
  updateFullPageLogo
} from '../api/index';
import SaveSettings from '../Components/FullPage/SaveSettings';
import SettingsTabs from '../Components/Shared/SettingsTabs';

const StyledContainer = styled.div`
  ${tw`flex flex-auto flex-col-reverse xl:flex-row xl:justify-start`}
`;

const StyledPanel = styled(Panel)``;

const FullPageSettings = () => {
  const [settingSection, setSettingSection] = useState('main');

  const { client } = useAuth();

  const deployment = {
    script:
      `<html>
  <style>
    body, html {
      padding: 0;
      margin: 0;
    }

    iframe {
      width: 100vw;
      height: 100vh;
      border: none;
    }
  </style>

  <body>
    <iframe src="${process.env.REACT_APP_FULL_PAGE_DEPLOYMENT_ROOT_URL}?c=${process.env.REACT_APP_INSTALL_NAME}&i=${client.identifier}" id="chat-widget-1925"></iframe>
  </body>
</html>`,
    info: 'Create a webpage with this snippet.'
  };

  return (
    <PageWrapper
      header="Full Page widget"
      prevAction={<BackButton to="/channels" />}
      subheader="Manage the appearance of your Full Page widget"
    >
      <BotSettingsProvider
        type="full-page"
        updateBotLogo={updateFullPageLogo}
        updateBotSettings={updateFullPageSettings}
        deploymentDetails={deployment}
      >
        <Flex xSpace>
          <OneHalfLayout>
            <StyledPanel>
              <Flex col growShrink>
                <SettingsTabs
                  section={settingSection}
                  onChange={setSettingSection}
                  sections={[
                    { key: 'main', label: 'Main' },
                    { key: 'design', label: 'Design' },
                    { key: 'advanced', label: 'Advanced' }
                  ]}
                />

                <StyledContainer>
                  <Flex col gap growShrink>
                    {settingSection === 'main' && (
                      <>
                        <DeploymentCode hideTitle />
                        <FullPageGeneralSettings />
                      </>
                    )}

                    {settingSection === 'design' && (
                      <>
                        <FullPageColourSettings />
                        <FontCode />
                      </>
                    )}

                    {settingSection === 'advanced' && (
                      <>
                        <SettingPageSettings />
                      </>
                    )}

                    <SaveSettings />
                  </Flex>
                </StyledContainer>
              </Flex>
            </StyledPanel>
          </OneHalfLayout>

          <OneHalfLayout>
            <FullPagePreview />
          </OneHalfLayout>
        </Flex>
      </BotSettingsProvider>
    </PageWrapper>
  );
};

export default FullPageSettings;